/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';
import { CreateUnixLocalAccessGroupModule } from 'app/feature/service/file-service/access-user/unix-access-user/unix-local-access-group/create-unix-local-access-group/create-unix-local-access-group.module';
import { CreateUnixLocalAccessUserModule } from 'app/feature/service/file-service/access-user/unix-access-user/unix-local-access-user/create-unix-local-access-user/create-unix-local-access-user.module';
import { CreateWindowsLocalAccessGroupModule } from 'app/feature/service/file-service/access-user/windows-access-user/windows-local-access-group/create-windows-local-access-group/create-windows-local-access-group.module';
import { CreateWindowsLocalAccessUserModule } from 'app/feature/service/file-service/access-user/windows-access-user/windows-local-access-user/create-windows-local-access-user/create-windows-local-access-user.module';
import { FileSystemGuideModule } from 'app/feature/service/file-service/file-system/file-system-guide/file-system-guide.module';

import { AddUserOrGroupComponent } from './add-user-or-group.component';

@NgModule({
    declarations: [AddUserOrGroupComponent],
    exports: [AddUserOrGroupComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        DMCommonModule,
        CreateWindowsLocalAccessUserModule,
        CreateWindowsLocalAccessGroupModule,
        FileSystemGuideModule,
        CreateUnixLocalAccessUserModule,
        CreateUnixLocalAccessGroupModule,
    ],
})
export class AddUserOrGroupModule { }
